/* eslint-disable import/no-cycle */
import { createActivity } from './activity';
import { PerfMarker } from './marker';
import {
  IInstrumentation, IActivity, IPerfMarkerOptions, IPerfActivity,
} from './types';

let instrumentation: IInstrumentation;
const filesFetched: string[] = [];

export class PerfMarkerFactory {
  static init(instr: IInstrumentation) {
    instrumentation = instr;
  }

  static createMarker(
    name: string,
    markerOptions: IPerfMarkerOptions = { autoEnd: false, isActiveChild: true },
    activity: IActivity = createActivity(instrumentation),
    parentMarker: PerfMarker = {} as PerfMarker,
  ) {
    const isFileFetched = filesFetched.indexOf(name) > -1;

    if (!isFileFetched) {
      filesFetched.push(name);
    }

    return new PerfMarker(name, markerOptions, isFileFetched, activity as IPerfActivity, parentMarker);
  }

  static isPerfMarker(obj: unknown): obj is PerfMarker {
    return obj instanceof PerfMarker;
  }

  static isInit() {
    return instrumentation !== null && instrumentation !== undefined;
  }
}
